// Modal Provider
export {ModalProvider, default as GlobalModalProvider} from './ModalProvider';

// Modal Components
export {ConfirmationModal} from './ConfirmationModal';
export {AlertModal} from './AlertModal';
export {UnAuthenticatedUserModal} from './UnAuthenticatedUserModal';
export {AboutPaymentOptionModal} from './AboutPaymentOptionModal';

// Types
export type {
    ModalConfig,
    ModalOptions,
    ModalSize,
    ConfirmationModalProps,
    AlertModalProps
} from '@/presentation/stores/ModalStore';

// Store
export {ModalStore} from '@/presentation/stores/ModalStore';

// Hooks
export {useModalStore} from '@/presentation/hooks/useStores';